// extracted by mini-css-extract-plugin
export default {"toast":"toast-x2n84","fade-in":"fade-in-WXtro","hide":"hide-6Hxcf","fade-out":"fade-out-v0w3O"};